import { useState, useEffect } from 'react';
import { FaPencilAlt, FaCheck, FaTimes } from 'react-icons/fa';

// Admin-only inline text editor.
// Renders as plain text for non-admin users.
// For admins: pencil icon → click to edit → save/cancel.
export default function EditableText({ value, canEdit, onSave, className = '' }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setDraft(value); }, [value]);

  if (!canEdit) {
    return <span className={className}>{value}</span>;
  }

  if (!editing) {
    return (
      <span className={`editable-text ${className}`}>
        {value}
        <button
          type="button"
          className="editable-edit-btn"
          onClick={() => setEditing(true)}
          title="Edit"
        >
          <FaPencilAlt />
        </button>
      </span>
    );
  }

  async function handleSave() {
    if (draft === value) { setEditing(false); return; }
    setSaving(true);
    const { error } = await onSave(draft);
    setSaving(false);
    if (!error) setEditing(false);
  }

  return (
    <span className={`editable-text editing ${className}`}>
      <input
        type="text"
        value={draft}
        onChange={e => setDraft(e.target.value)}
        autoFocus
        className="editable-input"
      />
      <button type="button" className="editable-save-btn" onClick={handleSave} disabled={saving}>
        <FaCheck />
      </button>
      <button type="button" className="editable-cancel-btn" onClick={() => { setDraft(value); setEditing(false); }}>
        <FaTimes />
      </button>
    </span>
  );
}
